/**
 * Epic LOCAIS-POR-CLIENTE — types for the grouped cliente→locais payload.
 *
 * These types mirror the backend schemas in `inventory/schemas_job.py`:
 * - ClienteLocaisIn → input payload (POST /jobs with cliente_locais)
 * - ClienteLocaisOut → response payload (GET /jobs/{id} .cliente_locais)
 * - LocalDoClienteOut → nested local inside ClienteLocaisOut
 *
 * Also includes the shape returned by GET /jobs/preview-locais-por-cliente,
 * which reuses ClienteLocaisOut.
 */
import type { LocalContagem } from './estabelecimento';

/** Single local inside a cliente's group (from backend). */
export interface LocalDoCliente {
  id: number;
  nome: string;
  responsavel?: string | null;
  /** True when this same local_id appears in 2+ clientes of the contagem. */
  is_shared: boolean;
}

/** One cliente group with its locais (preview and job response). */
export interface ClienteLocaisPreview {
  cliente_id: number;
  cliente_nome: string;
  locais: LocalDoCliente[];
}

/** Payload sent in POST/PUT /jobs .cliente_locais */
export interface ClienteLocaisPayload {
  cliente_id: number;
  local_ids: number[];
}

/** Convert a LocalDoCliente (from preview) into a full LocalContagem shape.
 *
 * The preview endpoint omits telefone/ramal/email/ativo since they're not
 * needed for the accordion UI. This helper pads the missing fields so the
 * hook can store LocalContagem objects (matching the old codepath). */
export function localDoClienteToLocalContagem(l: LocalDoCliente): LocalContagem {
  return {
    id: l.id,
    local: l.nome,
    responsavel: l.responsavel || '',
    telefone: '',
    ramal: '',
    email: '',
    ativo: true,
  };
}
